(function () {
  'use strict';

  /* @ngdoc object
   * @name exam
   * @description
   *
   */
  angular
    .module('vcexam', [
      'ui.router',
      'ngSanitize',
      'ngTagsInput',
      'ui.bootstrap.typeahead',
      'vcutils.doctor',
      'vcconsult',
      'vcutils.rlog',
      'ui.grid',
      'ui.grid.edit'
    ]);
}());
